import React from 'react'
import styled from 'styled-components'
import media from '../../utils/media'
import { useTranslations } from '../../utils/Text'
// eslint-disable-next-line import/no-cycle
import components from './index'

const Container = styled.div`
  background-color: ${props =>
    props.bgColor ? props.bgColor : 'transparent'};
  padding-top: ${props => props.verticalPadding}px;
  padding-bottom: ${props => props.verticalPadding}px;
  padding-left: ${props => props.horizontalPadding}px;
  padding-right: ${props => props.horizontalPadding}px;
  width: 102vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  margin-top: ${props => props.marginT}px;
  margin-bottom: ${props => props.marginB}px;
  ${media.mobileL`
    margin-top: calc(${props => props.marginT}px/3);
    margin-bottom: calc(${props => props.marginB}px/3);
    padding-top: calc(${props => props.verticalPadding}px/2);
    padding-bottom: calc(${props => props.verticalPadding}px/2);
    padding-left: calc(${props => props.horizontalPadding}px/4);
    padding-right: calc(${props => props.horizontalPadding}px/4);
  `}
`

const Wrapper = styled.div`
  max-width: 1170px;
  margin: 0 auto;
  text-align: center;
`

export default function Hero({ config, coupon }) {
  const {
    bgColor,
    horizontalPadding,
    verticalPadding,
    marginB,
    marginT,
    children,
    active,
  } = config

  const childrenExist =
    useTranslations(active, { optional: true }) !== null

  if (active && !childrenExist) return null
  return (
    <Container
      bgColor={bgColor}
      horizontalPadding={horizontalPadding}
      verticalPadding={verticalPadding}
      marginB={marginB}
      marginT={marginT}
    >
      <Wrapper>
        {children.map((item, i) => {
          const TypeComponent = components[item.type]
          return (
            <TypeComponent
              // eslint-disable-next-line react/no-array-index-key
              key={`componentChild-${item.type}-${i}`}
              coupon={coupon}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...item}
            />
          )
        })}
      </Wrapper>
    </Container>
  )
}
